function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModuleWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11914",
    d: "M7 12a5 5 0 1 1 5-5 5 5 0 0 1-5 5zm0-9.286A4.286 4.286 0 1 0 11.286 7 4.286 4.286 0 0 0 7 2.714z",
    transform: "translate(-2 -2)",
    style: {
      fill: "#c50f3c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11765"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3634",
    transform: "translate(4.644 2.143)",
    style: {
      fill: "#c50f3c"
    },
    d: "M0 0h.714v3.929H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11915",
    d: "M15.036 22a.536.536 0 1 0 .536.536.536.536 0 0 0-.536-.536z",
    transform: "translate(-10.035 -15.213)",
    style: {
      fill: "#c50f3c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleWarning);
export default __webpack_public_path__ + "static/media/module_warning.8b073f45d0e023bf762713800e2a40d8.svg";
export { ForwardRef as ReactComponent };